import React from 'react';
import { Route, Routes } from 'react-router-dom';

import AdverseDrivingDetails from 'containers/AdverseDrivingDetails';
import Citizenship from 'containers/Citizenship';
import CriminalHistory from 'containers/CriminalHistory';
import Finances from 'containers/Finances';
import HazardousActivities from 'containers/HazardousActivities';
import MarijuanaDetails from 'containers/MarijuanaDetails';
import MilitaryService from 'containers/MilitaryService';
import SubstanceUse from 'containers/SubstanceUse';
import Travel from 'containers/Travel';

import {
  CONTINUE_ONLINE_SUBSTANCE_USE_PATH,
  CONTINUE_ONLINE_MARIJUANA_PATH,
  CONTINUE_ONLINE_CRIMINAL_HISTORY_PATH,
  CONTINUE_ONLINE_ADVERSE_DRIVING_PATH,
  CONTINUE_ONLINE_MILITARY_SERVICE_PATH,
  CONTINUE_ONLINE_CITIZENSHIP_PATH,
  CONTINUE_ONLINE_HAZARDOUS_ACTIVITIES_PATH,
  CONTINUE_ONLINE_FINANCES_PATH,
  CONTINUE_ONLINE_TRAVEL_PATH,
} from '../constants';

export const LifeStyleRoutes: React.FC = () => (
  <Routes>
    <Route path={CONTINUE_ONLINE_SUBSTANCE_USE_PATH} element={<SubstanceUse />} />
    <Route path={CONTINUE_ONLINE_MARIJUANA_PATH} element={<MarijuanaDetails />} />
    <Route path={CONTINUE_ONLINE_CRIMINAL_HISTORY_PATH} element={<CriminalHistory />} />
    <Route path={CONTINUE_ONLINE_ADVERSE_DRIVING_PATH} element={<AdverseDrivingDetails />} />
    <Route path={CONTINUE_ONLINE_MILITARY_SERVICE_PATH} element={<MilitaryService />} />
    <Route path={CONTINUE_ONLINE_CITIZENSHIP_PATH} element={<Citizenship />} />
    <Route path={CONTINUE_ONLINE_HAZARDOUS_ACTIVITIES_PATH} element={<HazardousActivities />} />
    <Route path={CONTINUE_ONLINE_FINANCES_PATH} element={<Finances />} />
    <Route path={CONTINUE_ONLINE_TRAVEL_PATH} element={<Travel />} />
  </Routes>
);
